import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentsService } from '@services/documents.service';
import { OrdersService } from '@services/orders.service';
import { OrderDocumentsDialogData } from 'app/shared/models/types/types';
import { Document } from 'app/shared/models/classes/document/document';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-order-documents-dialog',
  templateUrl: './order-documents-dialog.component.html',
  styleUrls: ['./order-documents-dialog.component.scss']
})
export class OrderDocumentsDialogComponent implements OnInit {

  public documents: Document[] = [];

  public displayedColumns: string[] = ['fileName', 'action'];
  public dataSource = new MatTableDataSource<Document>();

  constructor(
    public dialogRef: MatDialogRef<OrderDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderDocumentsDialogData,

    private _ordersSrv: OrdersService,
    private _documentSrv: DocumentsService

  ) { }

  public ngOnInit(): void {
    this._fetchDocuments();
  }

  private _fetchDocuments(): void {
    this._ordersSrv.getDocuments$(this.data.orderId).subscribe((documents: Document[]) => {
      this.documents = documents;
      this.dataSource.data = this.documents;
    });
  }

  public onDownloadDocument(document: Document): void {
    this._documentSrv.downloadFile$(document.id).subscribe(() => {
      this._closeDialog();
    });
  }

  public onDownloadAll(): void {
    this._ordersSrv.downloadDocuments$(this.data.orderId).subscribe(() => {
      this._closeDialog();
    });
  }

  public onDismiss(): void {
    this._closeDialog();
  }

  private _closeDialog(): void {
    this.dialogRef.close();
  }
}
